import 'slick-carousel/slick/slick'

export default class PostsSlider {

	constructor() {

		this.settings = {
			$slider : $('.js-posts-slider')
		};

		this.bindUIActions();

	}

	bindUIActions() {

		if(this.settings.$slider.length) {

			this.settings.$slider.slick({
				infinite: true,
				slidesToShow: 4,
				slidesToScroll: 1,
				arrows: true,
				prevArrow: $('.js-posts-previous'),
				nextArrow: $('.js-posts-next'),

				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 640,
						settings: {
							slidesToShow: 1,
						}
					}
				]
			});

			const $slider = $('.js-posts-slider');

			const updateSlideIndex = () => {
				const slideIndexSelector = $('.post-slide-index');
				if ($slider.slick('slickCurrentSlide')<=8){
					slideIndexSelector.text('0'+($slider.slick('slickCurrentSlide')+1));
				}else{
					slideIndexSelector.text($slider.slick('slickCurrentSlide')+1);
				}
			}

			updateSlideIndex();
			$slider.on('afterChange', updateSlideIndex);

			const updateProgressBar = () => {
				let slidesNumber = $('#post-slides-number').text();
				let currentSlide = $slider.slick('slickCurrentSlide')+1;
				let calc = currentSlide * (100/slidesNumber);
				$('.js-posts-slider-progress').css('width', calc+'%');
			}

			updateProgressBar();
			$slider.on('afterChange', updateProgressBar);

		}

	}

};

new PostsSlider();